import { render, staticRenderFns } from "./TableHeaderSelector.vue?vue&type=template&id=66dee067&scoped=true&"
import script from "./TableHeaderSelector.vue?vue&type=script&lang=js&"
export * from "./TableHeaderSelector.vue?vue&type=script&lang=js&"
import style0 from "./TableHeaderSelector.vue?vue&type=style&index=0&id=66dee067&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dee067",
  null
  
)

export default component.exports